// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2hlVg","colCheckbox":"styles_colCheckbox__3XlkS"};